<template>
	<Col class="height-100 width-100">
		<AnalyticsTable :class="{ 'pb-12': isLoading }" :tableData="tableData" :customColumns="customColumns" />
		<AppLoader v-if="isLoading" class="mt-n8" />
	</Col>
</template>
<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsTable from '@/components/Analytics/Table/AnalyticsTable.vue';
import { getAnalyticsRunsByFeature } from '@/store/modules/analytics/actions.js';
import AnalyticsTopFeatureItem from '@/components/Analytics/Cards/Items/AnalyticsTopFeatureItem.vue';
export default {
	name: 'AnalyticsByUsers',
	mixins: [AnalyticsMixin],
	props: { includeAllSpacesForAdmin: { type: Boolean } },
	components: { AnalyticsTable },
	computed: {
		customColumns() {
			return [
				{
					key: 'flow_data',
					title: 'Feature',
					component: AnalyticsTopFeatureItem,
					getCustomCellProps: (cellValue) => ({ flowData: cellValue }),
				},
			];
		},
		tableData() {
			return this.populateTableDataWithCalculatedColumns(this.runsByFeature);
		},
	},
	methods: {
		...mapActionsShorthand({ getAnalyticsRunsByFeature }),
		async fetchData() {
			this.isLoading = true;
			const res = await this.getAnalyticsRunsByFeature({ spaceId: this.activeSpaceId, includeAllSpaces: this.includeAllSpacesForAdmin });
			this.isLoading = false;
			return res;
		},
	},
	async created() {
		await this.fetchData();
	},
	data() {
		return { isLoading: false };
	},
	watch: {
		includeAllSpacesForAdmin() {
			this.fetchData();
		},
	},
};
</script>
<style scoped lang="scss"></style>
